import { Controller as t } from "@hotwired/stimulus";
import e from "lodash/debounce";

function r(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, n(t, e);
}

function n(t, e) {
  return (n = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  })(t, e);
}

var o = function () {
  function t() {}

  return t.register = function (t, e) {
    this.registryList[t] = e;
  }, t.get = function (t) {
    return this.registryList[t];
  }, t;
}();

o.registryList = {};

var i = {
  reloadList: function reloadList(t, e) {
    if (t && e) return t.innerHTML = e.innerHTML;
    throw new Error("Target: " + t + ", template: " + e);
  },
  remove: function remove(t) {
    if (t) return t.remove();
    throw new Error("Target: " + t);
  }
},
    s = function (t) {
  function e() {
    return t.apply(this, arguments) || this;
  }

  r(e, t);
  var n = e.prototype;
  return n.connect = function () {
    o.register(this.nameValue, this);
  }, n.beforeSend = function (t) {
    switch (console.log("smart_listing: before", t), t.type) {
      case "ajax:beforeSend":
        t.detail[0].setRequestHeader("Accept", "text/vnd.smart-listing-remote.html");
        break;

      case "turbo:before-fetch-request":
        Turbo.navigator.history.replace(new URL(t.detail.url));
    }

    var e, r;
    return e = this.element, r = new Event("beforesend"), e.dispatchEvent(r), !0;
  }, n.performAction = function (t, e, r) {
    switch (t) {
      case "replace":
        return i.reloadList(e, r);

      case "remove":
        return i.remove(e);

      default:
        throw new Error("Unknown action: " + t);
    }
  }, n.update = function (t) {
    var e,
        r,
        n = this;

    if (console.log("smart_listing: update", t), "ajax:complete" == t.type) {
      var o = t.detail,
          i = o[0];
      "OK" === o[1] ? new DOMParser().parseFromString(i.response, "text/html").querySelectorAll("smart-listing-action").forEach(function (t) {
        var e = t.getAttribute("name"),
            r = t.getAttribute("target"),
            o = document.getElementById("" + r),
            i = t.querySelector("template");
        n.performAction(e, o, i);
      }) : console.error("Status " + i.status);
    }

    e = this.element, r = new Event("aftercomplete"), e.dispatchEvent(r);
  }, e;
}(t);

s.values = {
  name: String
};

var a = function (t) {
  function e() {
    return t.apply(this, arguments) || this;
  }

  return r(e, t), e.prototype.connect = function () {
    t.prototype.connect.call(this), console.log("hello from tailwind controller"), this.element.addEventListener("beforesend", function (t) {
      t.target.classList.add("opacity-25", "pointer-events-none", "transition-opacity");
    }), this.element.addEventListener("aftercomplete", function (t) {
      t.target.classList.remove("opacity-25", "pointer-events-none");
    });
  }, e;
}(s),
    c = function (t) {
  function n() {
    return t.apply(this, arguments) || this;
  }

  r(n, t);
  var o = n.prototype;
  return o.initialize = function () {
    this.refresh = e(this.refresh, 500).bind(this);
  }, o.connect = function () {}, o.disconnect = function () {}, o.refresh = function (t) {
    console.log("smart listing controls: refresh", t), this.element.requestSubmit();
  }, n;
}(t);

c.targets = ["observable"];
var u = {
  controllers: {
    main: {
      base: s,
      tailwind: a
    },
    controls: {
      base: c,
      tailwind: function (t) {
        function e() {
          return t.apply(this, arguments) || this;
        }

        return r(e, t), e;
      }(c)
    }
  },
  registry: o,
  actions: i
};
window.SmartListing = u;
export default u;